<template>
   <div class="mx-auto h-screen">
     <TakeSelfie />
   </div>
</template>

<script>
import TakeSelfie from "@/components/mobile/TakeSelfie.vue"

export default {
  name: 'Selfie',
  components: {
    TakeSelfie
  },
  mounted() {
    this.$i18n.locale = this.lang;
  },
  data() {
    return {
      lang: localStorage.getItem('language') ? localStorage.getItem('language') : 'ro',
    }
  }
}
</script>
